import { useTranslation } from 'react-i18next';
import { cn } from '@anytag/shared-utils';
import { PostDetailsType } from '@anytag/shared-types';
import { Anchor, MediaPreview } from '@anytag/shared-atoms';
import { SimilarPost, SocialPostType } from '@anytag/graphql';
import { useGenerateInfluencerProfileLink } from '@anytag/shared-hooks';

export interface SimilarPostsProps extends Pick<PostDetailsType, 'socialMedia'> {
  className?: string;
  posts?: readonly SimilarPost[];
}

export const SimilarPosts = ({ posts = [], className, socialMedia }: SimilarPostsProps) => {
  const { t } = useTranslation();
  const { generateProfileLink } = useGenerateInfluencerProfileLink();

  return posts?.length ? (
    <div className={cn('mt-4 box-border bg-black-10 p-4', className)}>
      <p className="m-0 text-sm leading-3.5 font-semibold text-black-90">{t('Similar Image Search')}</p>
      <div className="mt-1 box-border flex gap-x-2">
        {posts.slice(0, 4).map(({ image, influencerId: id, socialAccountId, username, postType }, index) => {
          const isReel = postType === SocialPostType.INSTAGRAM_REEL;

          return (
            <div key={index} className="box-border basis-1/4">
              <div className="flex flex-col items-center">
                <div className="relative h-0 w-full overflow-hidden rounded-sm pt-[100%]">
                  <MediaPreview src={image} isReel={isReel} className="absolute top-0 left-0 size-full" showIcon />
                </div>
                <Anchor
                  variant="blue"
                  title={username}
                  label={username}
                  className="mt-2"
                  {...generateProfileLink(
                    id,
                    socialAccountId ? { filter: { id: String(socialAccountId), sm: socialMedia || '' } } : undefined
                  )}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  ) : null;
};
